import React from 'react';
import { getProductTypeLabel, getFundsListPath } from '@finect/front-resources/Products';
import { useTheme } from 'styled-components';
import { ContentProductsCarousel } from '../../Products';
export var FundTopYTDFunds = function FundTopYTDFunds(_ref) {
  var productType = _ref.productType,
    funds = _ref.funds,
    subscriptions = _ref.subscriptions,
    _onFollow = _ref.onFollow,
    _ref$withSPA = _ref.withSPA,
    withSPA = _ref$withSPA === void 0 ? false : _ref$withSPA;
  var theme = useTheme();
  var plural = getProductTypeLabel(productType, 'plural', 'lowercase');
  return React.createElement(ContentProductsCarousel, {
    withSPA: withSPA,
    title: "".concat(productType.shortPlural, " que m\xE1s ganan este a\xF1o"),
    subtitle: "Los ".concat(plural, " m\xE1s rentables en Euros YTD"),
    products: funds.items,
    subscriptions: subscriptions || [],
    onFollow: function onFollow(id, status) {
      return _onFollow ? _onFollow(id, status) : function () {};
    },
    fetching: funds.fetching,
    variant: "large",
    bottomMargin: true,
    link: {
      href: getFundsListPath(theme, productType, {
        order: '-M12'
      }),
      text: "Ver ".concat(getProductTypeLabel(productType, 'shortPlural', 'lowercase'), " m\xE1s rentables en euros")
    }
  });
};